import React, {useEffect, useState} from 'react';
import ModalWindow from '../modal-window';
import {useIntl} from 'react-intl';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';
import Input from '../input';

import './style.scss';
import InputCheckbox from '../input-checkbox';

interface IChatroomConsentModalWindow {
  title: string
  onSave: (nickname: string) => void
  onClose: () => void
  show: boolean
  profileNickname: string | undefined
}

export const ChatroomConsentModalWindow = (
  {
    title,
    onSave,
    onClose,
    show,
    profileNickname
  }: IChatroomConsentModalWindow
): JSX.Element => {
  const intl = useIntl();
  const [nickname, setNickname] = useState<string>('');
  const [consent, setConsent] = useState<boolean>(false);
  const [error, setError] = useState<{ id: string; defaultMessage: string } | null>();

  useEffect(() => {
    if (profileNickname) {
      setNickname(profileNickname);
    }
  }, [profileNickname]);

  function handleClose() {
    onClose();
  }

  const getValidFormStatus = (): boolean => {
    if (!profileNickname && !consent) {
      setError({
        id: 'gritx.common.errors.required',
        defaultMessage: 'This field cannot be blank'
      });
    } else {
      setError(null);
    }

    return (!!profileNickname || consent) && !!nickname;
  };

  function handleSave() {
    if (getValidFormStatus()) {
      onSave(nickname);
    }
  }

  function handleChangeNickname(nick: string) {
    setNickname(nick);
  }

  function handleChangeConsent(isConsent: boolean) {
    setConsent(isConsent);
  }

  const content = () => {
    return <div className={'consent-form__container'}>
      <div className={'form-consent'}>
        <div className="form-consent__header">
          <h2 className="form-consent__title">{title}</h2>
        </div>
        <div className="form-consent__body">
          <Input
            required
            type="text"
            value={nickname}
            label={intl.formatMessage({
              id: 'gritx.chatroom.consent.card.nickname.label',
              defaultMessage: 'Nickname'
            })}
            onChange={handleChangeNickname}
          />
          {!profileNickname && <InputCheckbox value={consent}
            onChange={handleChangeConsent}
            label={intl.formatMessage(({
              id: 'gritx.chatroom.consent.card.consent',
              defaultMessage: 'Consent'
            }))}
            error={error}
          />}
        </div>
      </div>
    </div>;
  };

  const formsButtons = () => {
    return <div className="consent-form__footer">
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.common.button.cancel',
          defaultMessage: 'Cancel'
        })}
        variant={ButtonVariant.Light}
        className="consent-form__button"
        onClick={handleClose}
      />
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.common.button.save',
          defaultMessage: 'Save'
        })}
        variant={ButtonVariant.Primary}
        className="consent-form__button"
        onClick={handleSave}
      />
    </div>;
  };

  return <ModalWindow
    show={show}
    className="consent-form__modal"
    onHide={handleClose}
    footerElement={formsButtons()}
    shouldCloseOnOverlayClick={false}
  >
    {content()}
  </ModalWindow>;
};
